const Data = [
  {
    id: 1,
    category: "education",
    icon: "icon-graduation",
    year: "2019 - 2024",
    title: "Bachelor's Degree in Computer Engineering Higher Institutes of Engineering and Technology",
    desc: "Currently pursuing a Bachelor's degree with a focus on computer engineering. Gained a strong foundation in software development, algorithms, and system design.",
  },
  {
    id: 2,
    category: "education",
    icon: "icon-graduation",
    year: "2022 - 2023",
    title: "Artificial Intelligence and Applications Training Zewail City of Science and Technology",
    desc: "Completed a comprehensive training program in artificial intelligence and its applications. Acquired hands-on experience with machine learning models, data analysis, and AI-driven solutions.",
  },
  {
    id: 3,
    category: "education",
    icon: "icon-graduation",
    year: "2019 - present",
    title: "Self-Learning in Front-End Development and User Interface (UI)",
    desc: "Dedicated to continuous self-improvement and learning. Developed expertise in front-end technologies, including HTML, CSS, JavaScript, React.js, and Next.js. Focused on creating intuitive and user-friendly interfaces. ",
  },
  {
    id: 4,
    category: "experience",
    icon: "icon-briefcase",
    year: "2019 - present",
    title: "Freelancer Front-End Developer",
    desc: "With over 4 years of experience in designing, building, and customizing web projects, I have honed my skills in creating responsive and user-friendly interfaces. My expertise includes working with modern frameworks like React.js and Next.js, ensuring high performance and scalability for all my projects.",
  },
  {
    id: 5,
    category: "experience",
    icon: "icon-briefcase",
    year: "2022 - 2023",
    title: "Front-End Mentor at GDSC",
    desc: "As a Front-End Mentor at Google Developer Student Clubs (GDSC) Bihira, I guided students in learning and mastering front-end development technologies. I provided mentorship on various projects, helping students to build their own web applications and improve their coding skills. ",
  },
];
export default Data;
